import {
  NavigationProp,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { ColorPickerSelector } from "../../../../components";
import { Page } from "@towersystems/roam-common-native";
import { makeEventNotifier } from "../../../../utilities/events";

type ColorPickerScreenParams = {
  ColorPickerScreen: ColorPickerScreenConfig & {
    onColorPickerChange?: (color: string) => void;
  };
};

type ColorPickerScreenConfig = {
  defaultValue?: string;
  value?: string;
  hexList?: string[];
};

const notifer = makeEventNotifier<{ value: string }>("OnColorPickerChange");

export function showColorPicker(
  navigation: NavigationProp<any, any>,
  config: {
    defaultValue?: string;
    value?: string;
    hexList?: string[];
  }
) {
  navigation.navigate("ColorPickerScreen", config);
}

export function useColorPickerListener(
  listener: typeof notifer.notify,
  deps: ReadonlyArray<any>
) {
  notifer.useEventListener(listener, deps);
}

export function ColorPickerScreen() {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<ColorPickerScreenParams>>();
  const defaultColor = route.params?.defaultValue ?? "";
  const color = route.params?.value ?? "";
  const hexList = route.params?.hexList ?? [];

  const handleOnColorSelected = (newColor: string) => {
    notifer.notify({ value: newColor });
    navigation.goBack();
  };

  return (
    <Page>
      <ColorPickerSelector.ColorPicker
        defaultValue={defaultColor}
        value={color}
        hexList={hexList}
        onChange={handleOnColorSelected}
      />
    </Page>
  );
}
